<div class="container-fluid mar-top-15">
  <div class="offset-4 col-sm-6">
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="clientId"
             placeholder="Enter Client Id">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="loginName"
             placeholder="Enter User Id">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="typeId1"
             placeholder="Enter Incident Ticket Type Id">
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="cat1"
             placeholder="Enter Category 1 for Incident ticket type">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="cat2"
             placeholder="Enter Category 2 for Incident ticket type">
    </div>
     
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="typeId2"
             placeholder="Enter Problem Ticket Type Id">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="cat3"
             placeholder="Enter Category 1 for Problem ticket type ">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="cat4"
             placeholder="Enter Category 2 for Problem ticket type ">
    </div>
<!--    <div class="form-group">-->
<!--      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="srcType"-->
<!--             placeholder="Enter Source Type ">-->
<!--    </div>-->
    <button type="button" class="btn btn-success radius-0 font-13" (click)="save()">Create Ticket</button>
  </div>
</div>
